export default [{
  path: 'settlementsTransactList',
  name: 'settlementsTransactList',
  component: function component() {
    return import('@/views/settlementsManage/transactManage/index');
  }
}, {
  path: 'settlementsTransactAdd',
  name: 'settlementsTransactAdd',
  component: function component() {
    return import('@/views/settlementsManage/transactManage/add');
  }
}, {
  path: 'settlementsTransactDetail',
  name: 'settlementsTransactDetail',
  component: function component() {
    return import('@/views/settlementsManage/transactManage/detail');
  }
}, {
  path: 'settlementsInformationList',
  name: 'settlementsInformationList',
  component: function component() {
    return import('@/views/settlementsManage/informationManage/index');
  }
}, {
  path: 'settlementsInformationDetail',
  name: 'settlementsInformationDetail',
  component: function component() {
    return import('@/views/settlementsManage/informationManage/detail');
  }
}];